// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__14h7p","list":"PatternAutocomplete_list__1z-fj"};